// packages/shared/components/Security/SecuritySettings.jsx
import React, { useState } from 'react';
import AppButton from '@mysimpledb/shared/components/UI/Button/Button';

export default function SecuritySettings({
  state,
  handlers,
  mode = 'change' /* 'change' | 'reset' */,
}) {
  const {
    currentPassword,
    newPassword,
    confirmPassword,
    criteria,
    errors,
    status,
  } = state;

  const {
    setCurrentPassword,
    setNewPassword,
    setConfirmPassword,
    handleSubmit,
    validateCurrentPassword,
    currentPasswordInput,
  } = handlers;

  return (
    <div className="password-settings">
      <h2>{mode === 'reset' ? 'Reset Password' : 'Change Password'}</h2>

      <div className="section">
        {mode === 'change' && (
          <div className="form-group current">
            <label>Current Password</label>
            <input
              type="password"
              value={currentPassword}
              onChange={(e) => {
                setCurrentPassword(e.target.value);
              }}
              onBlur={validateCurrentPassword}
              onFocus={currentPasswordInput}
              className="standard-input"
              maxLength={256}
              style={{ width: '25ch' }}
            />
            {errors.current && (
              <div className="error">Current password incorrect</div>
            )}
          </div>
        )}

        <div className="form-group">
          <label>New Password</label>
          <input
            type="password"
            value={newPassword}
            onChange={(e) => setNewPassword(e.target.value)}
            className="standard-input"
            maxLength={256}
            style={{ width: '25ch' }}
          />

          <ul className="password-checklist">
            {Object.entries(criteria).map(([key, test]) => (
              <li key={key} className={test(newPassword) ? 'valid' : 'invalid'}>
                {
                  {
                    length: 'At least 8 characters',
                    upper: 'Uppercase letter',
                    lower: 'Lowercase letter',
                    digit: 'Number',
                    symbol: 'Symbol',
                  }[key]
                }
              </li>
            ))}
          </ul>
        </div>

        <div className="form-group">
          <label>Confirm New Password</label>
          <input
            type="password"
            value={confirmPassword}
            onChange={(e) => setConfirmPassword(e.target.value)}
            className="standard-input"
            maxLength={256}
            style={{ width: '25ch' }}
          />
          {errors.match && <div className="error">Passwords do not match</div>}
        </div>
      </div>

      {status && <div className="success">{status}</div>}

      <AppButton
        variant="solid"
        onPress={handleSubmit}
        disabled={
          !newPassword ||
          currentPassword.trim() === '' ||
          Object.keys(errors).length > 0
        }
      >
        {mode === 'reset' ? 'Set New Password' : 'Change Password'}
      </AppButton>
    </div>
  );
}
